import { CustomerDetails } from 'core_main/sdk/get_assistant/types';
import {
  UpdateCurrentCustomerParameters,
  UpdateCurrentCustomerParametersAttributes,
  CustomerSocial,
  GetCurrentCustomersContextApiResponse,
} from './types';

export const validateSocials = (socials: CustomerSocial[]) => {
  const validSocials = ['twitter', 'instagram', 'facebook', 'linkedin'];
  let invalidSocialError;

  socials.every((social) => {
    if (!social.type || !social.username) {
      invalidSocialError = new Error(
        'Social is missing one or more of the required properties: username, type',
      );
      return false;
    }

    if (!validSocials.includes(social.type)) {
      invalidSocialError = new Error(
        `${social.type} is not a valid social type. Socials must be one of: twitter, instagram, linkedin, facebook`,
      );
      return false;
    }

    return true;
  });

  return invalidSocialError;
};
export const validateCustomerAttributes = (
  attributes: UpdateCurrentCustomerParametersAttributes,
) => {
  /** These params for describeCustomer will be deprecated in favor of their `shared` counterparts */
  const deprecatedProperties = ['emails', 'phones', 'socials'];
  const validProperties = [
    'sharedEmails',
    'sharedPhones',
    'sharedSocials',
  ].concat(deprecatedProperties);

  let invalidError;

  Object.entries(attributes).every((entry) => {
    const key = entry[0];
    const value = entry[1];

    if (deprecatedProperties.includes(key)) {
      console.warn(
        `Kustomer: The attribute ${key} is deprecated. Please use shared${key
          .charAt(0)
          .toUpperCase()}${key.slice(1)} instead.`,
      );
    }

    if (!validProperties.includes(key)) {
      invalidError = new Error(
        `${key} is not a valid attribute. Attributes must contain at least one of: sharedEmails, sharedPhones, sharedSocials`,
      );
      return false;
    }

    if (key === 'socials' || key === 'sharedSocials') {
      invalidError = validateSocials(value);

      if (invalidError) return false;
    }

    return true;
  });

  return invalidError;
};
export const validateUpdateCurrentCustomerParams = (
  parameters: UpdateCurrentCustomerParameters,
) => {
  const attributes = parameters?.attributes;
  const customAttributes = parameters?.custom;

  if (!attributes && !customAttributes) {
    return new Error(
      'Missing one or more of the required properties: attributes, customAttributes',
    );
  }

  if (attributes) return validateCustomerAttributes(attributes);

  return undefined;
};

export const convertCurrentCustomerContextResponseToCustomerDetails = (
  response: GetCurrentCustomersContextApiResponse,
): CustomerDetails => {
  const {
    activityAt,
    createdAt,
    lastMessageAt,
    lastMessageSentAt,
    lastOutboundMsgSentAt,
    lastSeenAt,
    signedUpAt,
    lastMessageUnrespondedTo,
    avgSatisfactionRating,
    avgSatisfactionScore,
    name,
    email,
    phone,
    sentiment,
    company,
    custom,
  } = response?.data?.attributes || {};
  const { all, done, open, snoozed } =
    response?.data?.attributes?.conversationCount || {};
  const { id: createdBy } =
    response?.data?.relationships?.createdBy?.data || {};
  return {
    activityAt,
    createdAt,
    lastMessageAt,
    lastMessageSentAt,
    lastMessageOutSentAt: lastOutboundMsgSentAt,
    lastSeenAt,
    signedUpAt,
    lastMessageUnrespondedToSentAt: lastMessageUnrespondedTo,
    satisfactionLevel: {
      avgRating: avgSatisfactionRating,
      avgScore: avgSatisfactionScore,
    },
    conversationCounts: {
      all,
      done,
      open,
      snoozed,
    },
    name,
    email,
    phone,
    sentiment,
    company,
    createdBy,
    custom,
  };
};
